import { get } from 'app/utils/axios/kheti'
import { Farmer } from '../models/farmer'

interface Response {
  count: number
  next: string | null
  previous: string | null
  results: Farmer[]
}

const fetchFarmerList = async (
  search?: string,
  page?: number,
  offset?: number,
) => {
  try {
    const url = '/farmer-360/v1/vendor/farmers-list'
    return await get<Response>(url, { search, page, offset })
  } catch (e) {
    return null
  }
}

export default fetchFarmerList
